// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"HS-z"};